import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { DEFAULT_LANGUAGE, ISO3_TO_LANG } from './config';
import en from './locales/en.json';
import vi from './locales/vi.json';
import fil from './locales/fil.json';
export type { SupportedLanguage } from './config';
export {
  COUNTRY_TO_ISO3_ROUTE,
  ISO3_TO_LANG,
  SUPPORTED_LANGUAGES,
} from './config';

const RESOURCES = {
  en: { translation: en },
  vi: { translation: vi },
  fil: { translation: fil },
};

export const getInitialLanguage = (pathname?: string): string => {
  const fromPath = (pathname ?? '').split('/')[1] || '';
  if (ISO3_TO_LANG[fromPath]) return ISO3_TO_LANG[fromPath];
  if (typeof window !== 'undefined') {
    const stored = window.localStorage.getItem('app_language');
    if (stored && (RESOURCES as Record<string, unknown>)[stored]) return stored;
  }
  return DEFAULT_LANGUAGE;
};

export const initI18n = (lang: string = DEFAULT_LANGUAGE) => {
  const resolvedLang =
    lang ||
    (typeof window !== 'undefined'
      ? window.localStorage.getItem('app_language') || DEFAULT_LANGUAGE
      : DEFAULT_LANGUAGE);
  const storedLanguage =
    typeof window !== 'undefined'
      ? window.localStorage.getItem('app_language')
      : null;

  if (!i18n.isInitialized) {
    i18n.use(initReactI18next).init({
      resources: RESOURCES,
      lng: resolvedLang,
      fallbackLng: 'en',
      interpolation: { escapeValue: false },
    });
  } else if (i18n.language !== resolvedLang) {
    i18n.changeLanguage(resolvedLang);
  }

  if (typeof window !== 'undefined' && storedLanguage !== resolvedLang) {
    window.localStorage.setItem('app_language', resolvedLang);
  }

  return i18n;
};

// Eager init so SSR and module consumers see resources before any t() call.
// gatsby-browser.js will re-initialize with the correct pathname-derived
// language inside onClientEntry.
initI18n(
  getInitialLanguage(
    typeof window !== 'undefined' ? window.location.pathname : undefined,
  ),
);

export default i18n;
